import GetInfoCard from './GetInfoCard'

export default GetInfoCard
